import React from "react";
import { MdOutlineCopyright } from "react-icons/md";

import { Link } from "react-scroll";
import FooterInitials from "./FooterInitials";

function Footer() {
  return (
    <div id="footer" className="border border-t-2 border-gray-300 bg-white">
      <div className="text-center">
        <h1 className="lg:text-4xl my-6 text-3xl font-semibold">Kumar</h1>
      </div>
      <div className="text-center space-x-2 font-medium mb-5">
        <Link
          to="about"
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
          className="rounded-md cursor-pointer  transition-all duration-300 hover:text-white
        hover:bg-black p-[5px]"
        >
          About
        </Link>

        <Link
          to="portfolio"
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
          className="rounded-md cursor-pointer  transition-all duration-300 hover:text-white
        hover:bg-black p-[5px]"
        >
          Portfolio
        </Link>

        <Link
          to="qualification"
          spy={true}
          smooth={true}
          offset={-90}
          duration={500}
          className="rounded-md cursor-pointer  transition-all duration-300 hover:text-white
        hover:bg-black p-[5px]"
        >
          Qualification
        </Link>
      </div>
      {/*  */}
      <FooterInitials />
      <div className="mt-[60px] mb-[120px] lg:mb-[80px] gap-1 flex items-center justify-center ">
        <MdOutlineCopyright />
        <p>KumarShreyash. All Rights Reserved</p>
      </div>
    </div>
  );
}

export default Footer;
